/** Internal dependencies */
import { prepareApiCall } from './prepareApiCall';

export function handleActiveFiltersContainer(e) {
    const target = e.target.closest('button');
    if (!target) {
        return;
    }

    const parent = target.closest('[data-rest]');
    const { filterTaxonomy, filterTerm } = target.dataset;
    const input = parent.querySelector(`input[name="${filterTaxonomy}"][value="${filterTerm}"]`);
    if (input) {
        input.checked = false;
        target.remove();
        prepareApiCall(parent);
    }
}
